import type { FunctionComponent } from 'react'

import { H2 } from '@monthio/design-system'
import {
	AssetOverviewExplainerRealEstate,
	AssetOverviewExplainerRealVehicle,
} from '@monthio/icons'
import { useTranslation } from 'react-i18next'

import {
	ExplainerList,
	ExplainerListItem,
} from '../../../modulesTemp/general/FlowWizardUtils'

export const AssetOverviewIntro: FunctionComponent = () => {
	const { t } = useTranslation()
	return (
		<div>
			<H2>{t('assetOverview-intro-explainer-header')}</H2>
			<ExplainerList>
				<ExplainerListItem>
					<AssetOverviewExplainerRealEstate />
					{t('assetOverview-intro-explainer-real-estate')}
				</ExplainerListItem>
				<ExplainerListItem>
					<AssetOverviewExplainerRealVehicle />
					{t('assetOverview-intro-explainer-vehicle')}
				</ExplainerListItem>
			</ExplainerList>
		</div>
	)
}
